import {
  entitySchedulerPatient, dictionarydesignationsscheduler, workshift, schedulercalendar, scheduler,
  entityEmployeeWorkDay
} from '@/libs/acl/entities'

export default [
  {
    header: 'Schedule',
    icon: 'CalendarIcon',
    route: 'schedule',
    action: 'read',
    children: [
      {
        route: 'schedule-cabinets',
        title: 'Cabinet',
        resource: dictionarydesignationsscheduler,
        action: 'read',
      },
      {
        route: 'schedule-designations',
        title: 'Designations',
        resource: dictionarydesignationsscheduler,
        action: 'read',
      },
      {
        route: 'schedule-calendar',
        title: 'Schedule of reception',
        resource: entitySchedulerPatient,
        action: 'read',
      },
      {
        route: 'schedule-cabinet-calendar',
        title: 'Appointment schedule by cabinets',
        resource: entitySchedulerPatient,
        action: 'read',
      },
      {
        route: 'employee-schedule',
        title: 'Employee schedule',
        resource: [schedulercalendar, scheduler],
        action: 'read',
      },
      {
        route: 'shifts',
        title: 'Shifts',
        resource: workshift,
        action: 'read',
      },
      {
        route: 'time-tracking',
        title: 'Time tracking',
        resource: entityEmployeeWorkDay,
        action: 'read',
      }
    ]
  }
]
